import React from "react"
import PropTypes from 'prop-types'
import clearProps from '../../../utils/clearProps'

export default class Container extends React.Component {
  constructor(props) {
    super(props);

    this.config = {
      types : [],
      modifiers : [],
      states : []
    }

  }

  render() {
    const { children, fluid, className, ...rest } = this.props
    const props = clearProps(this.props)
    return <div {...props} className={ (fluid ? 'mdn-Container-fluid ' : 'mdn-Container ') + (className || '')}>
      {children}
    </div>
  }
}

Container.propTypes = {
  children : PropTypes.node
}